import {
    createSelector, createSlice,
} from "@reduxjs/toolkit";
import { RequestStatus } from "../../Model/Enums";
import { IAppState } from "../store";
import { getPendingApprovals1Thunk, getApprovalDetails1Thunk, postDeleteApprovals1Thunk, deleteApprovals1Thunk, systemSlice1Reducer, ISystemSlice1State } from "../SystemTemplate/SystemSlice1";

export const watershedSliceInitialState: ISystemSlice1State = {
    pendingApprovalsStatus: RequestStatus.Idle,
    pendingApprovalsError: null,
    selectedApprovalDetailStatus: RequestStatus.Idle,
    selectedApprovalDetailError: null,
    supportMulti: false,
    selectedApproval: null,
    selectedApprovalDetails: null,
    multiSelectedApprovals: [],
    searchQuery: "",
    isAsc: false,
    selectedSubSystem: null,
    fromPosition: 0,
    subSystems: [],
    totalCountForFilter: 0,
    pendingApprovals: [],
    isTabletView: false,

};


const WatershedSlice = createSlice({
    name: "Watershed",
    initialState: watershedSliceInitialState,
    reducers: systemSlice1Reducer
});

export const GetPendingApprovals = getPendingApprovals1Thunk(watershedSliceInitialState, WatershedSlice, "Watershed", "Watershed");

export const GetApprovalDetails = getApprovalDetails1Thunk(WatershedSlice, "Watershed", "Watershed");

export const PostDeleteApprovals = postDeleteApprovals1Thunk(WatershedSlice, "Watershed");

export const DeleteApprovals = deleteApprovals1Thunk(WatershedSlice, "Watershed", "Watershed");

//Action
export const {
    resetSystemSliceState,
    setPendingApprovalsStatus,
    setSelectedApproval,
    setSelectedApprovalDetails,
    setMultiSelectedApprovals,
    setSearchQuery,
    setIsAsc,
    setSelectedSubSystem,
    setFromPosition,
    setSubSystems,
    setTotalCountForFilter,
    setPendingApprovals,
    addToPendingApprovals,
    reCalculateSelectedApproval,
    setIsTabletView,
} = WatershedSlice.actions;

//Selector
export const WatershedSelector = (state: IAppState) => state.Watershed;
export const PendingApprovalsStatusSelector = createSelector(
    WatershedSelector,
    (details) => details?.pendingApprovalsStatus
);
export const PendingApprovalsErrorSelector = createSelector(
    WatershedSelector,
    (details) => details?.pendingApprovalsError
);
export const SelectedApprovalDetailStatusSelector = createSelector(
    WatershedSelector,
    (details) => details?.selectedApprovalDetailStatus
);
export const SelectedApprovalDetailErrorSelector = createSelector(
    WatershedSelector,
    (details) => details?.selectedApprovalDetailError
);
export const SupportMultiSelector = createSelector(
    WatershedSelector,
    (details) => details?.supportMulti
);
export const SelectedApprovalSelector = createSelector(
    WatershedSelector,
    (details) => details?.selectedApproval
);
export const SelectedApprovalDetailsSelector = createSelector(
    WatershedSelector,
    (details) => details?.selectedApprovalDetails
);
export const MultiSelectedApprovalsSelector = createSelector(
    WatershedSelector,
    (details) => details?.multiSelectedApprovals
);
export const SearchQuerySelector = createSelector(
    WatershedSelector,
    (details) => details?.searchQuery
);
export const IsAscSelector = createSelector(
    WatershedSelector,
    (details) => details?.isAsc
);
export const SelectedSubSystemSelector = createSelector(
    WatershedSelector,
    (details) => details?.selectedSubSystem
);
export const FromPositionSelector = createSelector(
    WatershedSelector,
    (details) => details?.fromPosition
);
export const SubSystemsSelector = createSelector(
    WatershedSelector,
    (details) => details?.subSystems
);
export const TotalCountForFilterSelector = createSelector(
    WatershedSelector,
    (details) => details?.totalCountForFilter
);
export const PendingApprovalsSelector = createSelector(
    WatershedSelector,
    (details) => details?.pendingApprovals
);
export const IsTabletViewSelector = createSelector(
    WatershedSelector,
    (details) => details?.isTabletView
);


export const WatershedReducer = WatershedSlice.reducer;

